// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Brand colors for Ace Success Team */
:root {
  --ace-dark: #0a3c2f;
  --ace-green: #007c4f;
  --ace-yellow: #ffd600;
  --ink: #0f172a;
  --muted: #334155;
}

.about-page {
  background-color: #fff;
  overflow-x: hidden;
}

/* === Banner Section === */
.about-banner {
  position: relative;
  width: 100%;
  height: 60vh;
  overflow: hidden;
}

.about-banner-image {
  width: 100%;
  height: 100%;
  object-fit: cover; /* keep your background image as-is */
}

/* UPDATED overlay (modern + same vibe as services heading) */
.about-banner-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;

  /* light overlay so the hero looks like your services screenshot */
  background: rgba(255, 255, 255, 0.78);
  /* backdrop-filter: blur(6px); */
  /* -webkit-backdrop-filter: blur(6px); */

  padding: 0 18px;
}

/* Small kicker */
.about-kicker {
  margin: 0 0 10px;
  font-weight: 800;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  color: rgba(10, 60, 47, 0.85);
  font-size: 12px;
}

/* Main heading */
.about-hero-title {
  margin: 0;
  font-size: 3rem;
  font-weight: 900;
  line-height: 1.1;
}

.about-title-dark {
  color: var(--ace-dark);
}

.about-title-green {
  color: var(--ace-green);
}

/* Gradient underline (green → yellow) */
.about-hero-underline {
  width: 150px;
  height: 6px;
  margin: 16px auto 16px;
  border-radius: 999px;
  background: linear-gradient(90deg, var(--ace-green), var(--ace-yellow));
}

/* Subtitle */
.about-hero-subtitle {
  margin: 0;
  font-size: 1.05rem;
  color: var(--muted);
  max-width: 760px;
  line-height: 1.7;
  font-weight: 500;
}

/* === About Content === */
.about-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 80px 20px;
  gap: 40px;
  max-width: 1100px;
  margin: 0 auto;
}

@media (min-width: 768px) {
  .about-content {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
}

.about-text {
  flex: 1 1;
}

.about-text h2 {
  color: var(--ace-green);
  font-size: 2rem;
  margin-bottom: 20px;
}

.about-text p {
  font-size: 1.1rem;
  line-height: 1.7;
  color: #333;
  margin-bottom: 15px;
}

.about-image {
  flex: 1 1;
  text-align: center;
}

.about-image img {
  width: 100%;
  max-width: 450px;
  border-radius: 10px;
  box-shadow: 0 6px 15px rgba(0, 0, 0, 0.1);
}

/* === Experience Section === */
.about-difference {
  background: #f4f6fd;
  padding: 80px 20px;
  text-align: center;
}

.difference-text {
  max-width: 850px;
  margin: 0 auto;
}

.difference-text h2 {
  font-size: 1.9rem;
  color: var(--ace-green);
  margin-bottom: 20px;
}

.difference-text p {
  font-size: 1.1rem;
  line-height: 1.7;
  color: #333;
}

/* === Responsive === */
@media (max-width: 768px) {
  .about-hero-title {
    font-size: 2.2rem;
  }

  .about-hero-subtitle {
    font-size: 1rem;
  }

  .about-content {
    padding: 60px 15px;
  }

  .about-text h2 {
    font-size: 1.6rem;
  }

  .difference-text h2 {
    font-size: 1.6rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/AboutUs/AboutUs.css"],"names":[],"mappings":"AAAA,sCAAsC;AACtC;EACE,mBAAmB;EACnB,oBAAoB;EACpB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB,EAAE,qCAAqC;AAC1D;;AAEA,6DAA6D;AAC7D;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;;EAElB,kEAAkE;EAClE,qCAAqC;EACrC,gCAAgC;EAChC,wCAAwC;;EAExC,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,6BAA6B;EAC7B,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA,wCAAwC;AACxC;EACE,YAAY;EACZ,WAAW;EACX,sBAAsB;EACtB,oBAAoB;EACpB,uEAAuE;AACzE;;AAEA,aAAa;AACb;EACE,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE;IACE,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;EACrB;AACF;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA,+BAA+B;AAC/B;EACE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;AACb;;AAEA,uBAAuB;AACvB;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":["/* Brand colors for Ace Success Team */\n:root {\n  --ace-dark: #0a3c2f;\n  --ace-green: #007c4f;\n  --ace-yellow: #ffd600;\n  --ink: #0f172a;\n  --muted: #334155;\n}\n\n.about-page {\n  background-color: #fff;\n  overflow-x: hidden;\n}\n\n/* === Banner Section === */\n.about-banner {\n  position: relative;\n  width: 100%;\n  height: 60vh;\n  overflow: hidden;\n}\n\n.about-banner-image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover; /* keep your background image as-is */\n}\n\n/* UPDATED overlay (modern + same vibe as services heading) */\n.about-banner-overlay {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n\n  /* light overlay so the hero looks like your services screenshot */\n  background: rgba(255, 255, 255, 0.78);\n  /* backdrop-filter: blur(6px); */\n  /* -webkit-backdrop-filter: blur(6px); */\n\n  padding: 0 18px;\n}\n\n/* Small kicker */\n.about-kicker {\n  margin: 0 0 10px;\n  font-weight: 800;\n  letter-spacing: 0.4px;\n  text-transform: uppercase;\n  color: rgba(10, 60, 47, 0.85);\n  font-size: 12px;\n}\n\n/* Main heading */\n.about-hero-title {\n  margin: 0;\n  font-size: 3rem;\n  font-weight: 900;\n  line-height: 1.1;\n}\n\n.about-title-dark {\n  color: var(--ace-dark);\n}\n\n.about-title-green {\n  color: var(--ace-green);\n}\n\n/* Gradient underline (green → yellow) */\n.about-hero-underline {\n  width: 150px;\n  height: 6px;\n  margin: 16px auto 16px;\n  border-radius: 999px;\n  background: linear-gradient(90deg, var(--ace-green), var(--ace-yellow));\n}\n\n/* Subtitle */\n.about-hero-subtitle {\n  margin: 0;\n  font-size: 1.05rem;\n  color: var(--muted);\n  max-width: 760px;\n  line-height: 1.7;\n  font-weight: 500;\n}\n\n/* === About Content === */\n.about-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 80px 20px;\n  gap: 40px;\n  max-width: 1100px;\n  margin: 0 auto;\n}\n\n@media (min-width: 768px) {\n  .about-content {\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n  }\n}\n\n.about-text {\n  flex: 1;\n}\n\n.about-text h2 {\n  color: var(--ace-green);\n  font-size: 2rem;\n  margin-bottom: 20px;\n}\n\n.about-text p {\n  font-size: 1.1rem;\n  line-height: 1.7;\n  color: #333;\n  margin-bottom: 15px;\n}\n\n.about-image {\n  flex: 1;\n  text-align: center;\n}\n\n.about-image img {\n  width: 100%;\n  max-width: 450px;\n  border-radius: 10px;\n  box-shadow: 0 6px 15px rgba(0, 0, 0, 0.1);\n}\n\n/* === Experience Section === */\n.about-difference {\n  background: #f4f6fd;\n  padding: 80px 20px;\n  text-align: center;\n}\n\n.difference-text {\n  max-width: 850px;\n  margin: 0 auto;\n}\n\n.difference-text h2 {\n  font-size: 1.9rem;\n  color: var(--ace-green);\n  margin-bottom: 20px;\n}\n\n.difference-text p {\n  font-size: 1.1rem;\n  line-height: 1.7;\n  color: #333;\n}\n\n/* === Responsive === */\n@media (max-width: 768px) {\n  .about-hero-title {\n    font-size: 2.2rem;\n  }\n\n  .about-hero-subtitle {\n    font-size: 1rem;\n  }\n\n  .about-content {\n    padding: 60px 15px;\n  }\n\n  .about-text h2 {\n    font-size: 1.6rem;\n  }\n\n  .difference-text h2 {\n    font-size: 1.6rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
